import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgThunderSalmonHeart = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 33,
	height: 33,
	viewBox: "0 0 33 33",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsxs("mask", {
			id: "path-1-outside-1_4164_63504",
			"mask-units": "userSpaceOnUse",
			x: 3.10547,
			y: 4.48438,
			width: 27,
			height: 25,
			fill: "black",
			children: [/* @__PURE__ */ _jsx("rect", {
				fill: "white",
				x: 3.10547,
				y: 4.48438,
				width: 27,
				height: 25
			}), /* @__PURE__ */ _jsx("path", { d: "M26.8108 17.2866L16.4983 27.5001L6.18584 17.2866C5.50563 16.6247 4.96985 15.8291 4.61222 14.9499C4.25459 14.0708 4.08286 13.1271 4.10785 12.1783C4.13284 11.2296 4.35401 10.2962 4.75743 9.43715C5.16085 8.57805 5.73777 7.81178 6.45188 7.18661C7.16599 6.56143 8.00181 6.09088 8.9067 5.8046C9.8116 5.51831 10.766 5.42249 11.7097 5.52316C12.6535 5.62384 13.5661 5.91883 14.3903 6.38956C15.2144 6.86029 15.9322 7.49656 16.4983 8.25831C17.0669 7.50209 17.7855 6.87138 18.6091 6.40564C19.4327 5.93991 20.3435 5.64918 21.2846 5.55165C22.2257 5.45412 23.1768 5.55189 24.0784 5.83885C24.98 6.1258 25.8126 6.59576 26.5242 7.21931C27.2358 7.84286 27.811 8.60658 28.2139 9.46266C28.6168 10.3187 28.8386 11.2488 28.8655 12.1945C28.8924 13.1403 28.7238 14.0814 28.3703 14.959C28.0167 15.8366 27.4858 16.6318 26.8108 17.2948" })]
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M26.8108 17.2866L16.4983 27.5001L6.18584 17.2866C5.50563 16.6247 4.96985 15.8291 4.61222 14.9499C4.25459 14.0708 4.08286 13.1271 4.10785 12.1783C4.13284 11.2296 4.35401 10.2962 4.75743 9.43715C5.16085 8.57805 5.73777 7.81178 6.45188 7.18661C7.16599 6.56143 8.00181 6.09088 8.9067 5.8046C9.8116 5.51831 10.766 5.42249 11.7097 5.52316C12.6535 5.62384 13.5661 5.91883 14.3903 6.38956C15.2144 6.86029 15.9322 7.49656 16.4983 8.25831C17.0669 7.50209 17.7855 6.87138 18.6091 6.40564C19.4327 5.93991 20.3435 5.64918 21.2846 5.55165C22.2257 5.45412 23.1768 5.55189 24.0784 5.83885C24.98 6.1258 25.8126 6.59576 26.5242 7.21931C27.2358 7.84286 27.811 8.60658 28.2139 9.46266C28.6168 10.3187 28.8386 11.2488 28.8655 12.1945C28.8924 13.1403 28.7238 14.0814 28.3703 14.959C28.0167 15.8366 27.4858 16.6318 26.8108 17.2948",
			fill: "url(#paint0_linear_4164_63504)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M27.5145 17.9971C27.9069 17.6084 27.91 16.9753 27.5213 16.5829C27.1327 16.1905 26.4996 16.1874 26.1071 16.576L27.5145 17.9971ZM16.4983 27.5001L15.7946 28.2106C16.1844 28.5966 16.8123 28.5966 17.202 28.2106L16.4983 27.5001ZM6.18584 17.2866L6.88955 16.576L6.88324 16.5699L6.18584 17.2866ZM16.4983 8.25831L15.6957 8.85483C15.8838 9.10789 16.1802 9.25743 16.4956 9.25831C16.8109 9.25918 17.1081 9.1113 17.2976 8.85929L16.4983 8.25831ZM26.1101 16.5814C25.7161 16.9684 25.7104 17.6015 26.0974 17.9955C26.4844 18.3896 27.1176 18.3952 27.5116 18.0082L26.1101 16.5814ZM26.1071 16.576L15.7946 26.7895L17.202 28.2106L27.5145 17.9971L26.1071 16.576ZM17.202 26.7895L6.88953 16.576L5.48215 17.9971L15.7946 28.2106L17.202 26.7895ZM6.88324 16.5699C6.30197 16.0042 5.84412 15.3244 5.53851 14.5731L3.68593 15.3267C4.09557 16.3338 4.70929 17.2451 5.48844 18.0032L6.88324 16.5699ZM5.53851 14.5731C5.2329 13.8219 5.08615 13.0154 5.10751 12.2047L3.1082 12.152C3.07957 13.2388 3.27628 14.3197 3.68593 15.3267L5.53851 14.5731ZM5.10751 12.2047C5.12886 11.3939 5.31786 10.5963 5.6626 9.8622L3.85226 9.0121C3.39016 9.99615 3.13683 11.0652 3.1082 12.152L5.10751 12.2047ZM5.6626 9.8622C6.00734 9.12806 6.50035 8.47325 7.11059 7.93901L5.79318 6.4342C4.9752 7.15032 4.31436 8.02804 3.85226 9.0121L5.6626 9.8622ZM7.11059 7.93901C7.72082 7.40477 8.43507 7.00266 9.20834 6.75802L8.60507 4.85117C7.56855 5.1791 6.61116 5.71809 5.79318 6.4342L7.11059 7.93901ZM9.20834 6.75802C9.98162 6.51337 10.7972 6.43149 11.6036 6.51752L11.8158 4.5288C10.7348 4.41349 9.64158 4.52325 8.60507 4.85117L9.20834 6.75802ZM11.6036 6.51752C12.4101 6.60355 13.1901 6.85563 13.8943 7.25789L14.8863 5.52122C13.9422 4.98202 12.8968 4.64412 11.8158 4.5288L11.6036 6.51752ZM13.8943 7.25789C14.5986 7.66015 15.2119 8.20388 15.6957 8.85483L17.3009 7.66179C16.6524 6.78924 15.8303 6.06042 14.8863 5.52122L13.8943 7.25789ZM17.2976 8.85929C17.7835 8.21306 18.3976 7.67409 19.1013 7.2761L18.1169 5.53519C17.1735 6.06866 16.3504 6.79112 15.6991 7.65733L17.2976 8.85929ZM19.1013 7.2761C19.8051 6.87811 20.5835 6.62967 21.3877 6.54632L21.1815 4.55698C20.1035 4.66869 19.0602 5.00171 18.1169 5.53519L19.1013 7.2761ZM21.3877 6.54632C22.1919 6.46298 23.0047 6.54653 23.7751 6.79175L24.3817 4.88595C23.349 4.55726 22.2595 4.44526 21.1815 4.55698L21.3877 6.54632ZM23.7751 6.79175C24.5456 7.03696 25.2571 7.43856 25.8652 7.97141L27.1833 6.46721C26.3682 5.75296 25.4144 5.21464 24.3817 4.88595L23.7751 6.79175ZM25.8652 7.97141C26.4733 8.50426 26.9648 9.15689 27.3091 9.88846L29.1187 9.03686C28.6573 8.05626 27.9984 7.18145 27.1833 6.46721L25.8652 7.97141ZM27.3091 9.88846C27.6534 10.62 27.8429 11.4148 27.8659 12.223L29.8651 12.1661C29.8343 11.0828 29.5802 10.0175 29.1187 9.03686L27.3091 9.88846ZM27.8659 12.223C27.8889 13.0312 27.7448 13.8354 27.4427 14.5854L29.2978 15.3327C29.7028 14.3274 29.8959 13.2494 29.8651 12.1661L27.8659 12.223ZM27.4427 14.5854C27.1406 15.3353 26.6869 16.0148 26.1101 16.5814L27.5116 18.0082C28.2847 17.2488 28.8929 16.338 29.2978 15.3327L27.4427 14.5854Z",
			fill: "#F12354",
			mask: "url(#path-1-outside-1_4164_63504)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M6.6296 8.42331L6 9.14286H15L14.3704 8.42331C12.3214 6.08163 8.67858 6.08163 6.6296 8.42331Z",
			fill: "url(#paint1_linear_4164_63504)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M18.6296 8.42331L18 9.14286H27L26.3704 8.42331C24.3214 6.08163 20.6786 6.08163 18.6296 8.42331Z",
			fill: "url(#paint2_linear_4164_63504)"
		}),
		/* @__PURE__ */ _jsxs("defs", { children: [
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint0_linear_4164_63504",
				x1: 6.87874,
				y1: 5.39193,
				x2: 18.4061,
				y2: 21.7534,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#FFEB37" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#FF4994"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint1_linear_4164_63504",
				x1: 10.5,
				y1: 6.57143,
				x2: 10.5,
				y2: 9.14286,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "white" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "white",
					stopOpacity: 0
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint2_linear_4164_63504",
				x1: 22.5,
				y1: 6.57143,
				x2: 22.5,
				y2: 9.14286,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "white" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "white",
					stopOpacity: 0
				})]
			})
		] })
	]
});
export default SvgThunderSalmonHeart;
